/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Snackbar as MuiSnackbar } from '@mui/material';
import { selectSuccessSnackbar } from '../../../../store/selectors';
import { clearSnackbar } from '../../../../store/actions/ui';

const SuccessSnackbar = () => {
  const dispatch = useDispatch();

  const message = useSelector(selectSuccessSnackbar);

  const handleClose = () => {
    dispatch(clearSnackbar());
  };

  return (
    <MuiSnackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      open={!!message}
      autoHideDuration={4000}
      onClose={handleClose}
    >
      <Alert severity="success">{message}</Alert>
    </MuiSnackbar>
  );
};

export default SuccessSnackbar;
